import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import * as React from "react";
import {useEffect} from "react";
import {ILanguageItem, languageMenuItems} from "./LanguageDropdownHelper";
import {RootState, useAppDispatch, useAppSelector} from "../../../store";
import {ListItemIcon, ListItemText} from "@mui/material";
import {changeDefaultLanguage} from "../../../store/auth/ActionCreators";
import {changeLanguage} from "../../../store/app/Slice";

const LanguageDropdown = () => {
    const dispatch = useAppDispatch()
    const userDefaultLanguage = useAppSelector((state: RootState) => state.authReducer.loggedInUser.default_locale)
    const language = useAppSelector((state: RootState) => state.appReducer.language)
    const token = useAppSelector((state: RootState) => state.authReducer.loggedInUser.access_token)
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [selectedLanguage, setSelectedLanguage] = React.useState<ILanguageItem>(languageMenuItems[0])
    const languageLoading = useAppSelector((state: RootState) => state.authReducer.changeLocaleLoading)

    useEffect(() => {
        const newLanguage = languageMenuItems.find(l => l.tag === userDefaultLanguage) ??
            languageMenuItems.find(l => l.tag === language) ??
            languageMenuItems[0]
        setSelectedLanguage(newLanguage)
    }, [userDefaultLanguage, language]);

    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleChooseLanguage = (language: ILanguageItem) => {
        if (!!token) {
            dispatch(changeDefaultLanguage(language.tag))
        } else {
            setSelectedLanguage(languageMenuItems.find(l => l.tag === language.tag) ?? languageMenuItems[0])
        }
        dispatch(changeLanguage(language.tag))
        handleCloseMenu()
    }

    return (
        <Box sx={{flexGrow: 0}}>
                <IconButton onClick={handleOpenMenu} sx={{p: 0}} disabled={languageLoading}>
                    <Avatar sx={{width: 24, height: 24}} alt="Language icon" src={selectedLanguage.flag}/>
                </IconButton>
            <Menu
                sx={{mt: 1}}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
            >
                {languageMenuItems.map((language, idx) => (
                    <MenuItem key={`language-menu-item-${idx}`} onClick={() => handleChooseLanguage(language)}>
                        <ListItemIcon>
                            <img src={language.flag} alt={`flag-${language.tag}`} width={25}/>
                        </ListItemIcon>
                        <ListItemText>{language.label}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    )
}

export default LanguageDropdown
